import { cn } from '@core-utils/cn';
import { forwardRef } from 'react';

import styles from './Form.module.scss';

type FormMessageProps = React.HTMLAttributes<HTMLParagraphElement>;

const FormMessage = forwardRef<HTMLParagraphElement, FormMessageProps>(
    function FormMessage({ className, ...props }, ref) {
        return (
            <p
                ref={ref}
                className={cn(styles.FormMessage, className)}
                {...props}
            />
        );
    },
);

export { FormMessage };
